import React from 'react'

function Project() {
  return (
    <>
    <section class="projects-section bg-light" id="projects">
            <div class="container px-4 px-lg-5">
                {/* <!-- Featured Project Row--> */}
                <div class="row gx-0 mb-4 mb-lg-5 align-items-center">
                    <div class="col-xl-1 col-lg-7"></div>
                    <div class="col-xl-4 col-lg-5">
                        <div class="featured-text text-center text-lg-left">
                            <h4>Recommended Foods</h4>
                            <p class="text-black-50 mb-0">เป็นที่นิยมในหมวดอาหาร</p>
                        </div>
                    </div>
                </div>
                {/* <!-- Project One Row--> */}
                <div class="row gx-0 mb-5 mb-lg-0 justify-content-center">
                    <div class="col-lg-6"><img class="img-fluid" src="assets/img/recom/r1.jpg" alt="..." /></div>
                    <div class="col-lg-6">
                        <div class="bg-black text-center h-100 project">
                            <div class="d-flex h-100">
                                <div class="project-text w-100 my-auto text-center text-lg-left">
                                    <h4 class="text-white">สเต็กหมู / -149 ฿ </h4>
                                    <p class="mb-0 text-white-50">"จานเด็ดชื่อดังของร้าน เนื้อสเต็กสันคอฉ่ำๆ ชิ้นหนานุ่ม ทานคู่กับซอสเกรวี่ รสชาติกลมกล่อม อร่อยลงตัว"</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- Project Two Row--> */}
                <div class="row gx-0 justify-content-center">
                    <div class="col-lg-6"><img class="img-fluid" src="assets/img/recom/r2.jpg" alt="..." /></div>
                    <div class="col-lg-6 order-lg-first">
                        <div class="bg-black text-center h-100 project">
                            <div class="d-flex h-100">
                                <div class="project-text w-100 my-auto text-center text-lg-right">
                                    <h4 class="text-white">สเต็กปลาแซลมอน / -249 ฿ </h4>
                                    <p class="mb-0 text-white-50">"จานโปรดของใครหลายๆ คน คัดสรรเนื้อปลาชิ้นโต เนื้อแน่น ทางร้านกริลปลาแซลมอนด้วยไฟอ่อนๆ กลิ่นหอม ทำให้ได้เนื้อปลาที่ยังคงความชุ่มฉ่ำ และหนังที่กรุบกรอบกำลังดี ทานคู่กับซอสสูตรเฉพาะของทางร้าน 
                                    เป็นอีกหนึ่งเมนู ที่ไม่ควรพลาด"</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row gx-0 mb-5 mb-lg-0 justify-content-center">
                    <div class="col-lg-6"><img class="img-fluid" src="assets/img/recom/r3.jpg" alt="..." /></div>
                    <div class="col-lg-6">
                        <div class="bg-black text-center h-100 project">
                            <div class="d-flex h-100">
                                <div class="project-text w-100 my-auto text-center text-lg-left">
                                    <h4 class="text-white">สลัดกุ้งทอด / -109 ฿</h4>
                                    <p class="mb-0 text-white-50">"เอาใจสาย healthy ด้วยเมนูสลัดกุ้งทอด ผักสด กรอบ คลุกเคล้าด้วยน้ำสลัดแสนอร่อย กุ้งสดๆ ชุบแป้ง นำไปทอดจนกรอบเป็นสีเหลืองทอง เนื้อกุ้งนุ่ม เด้ง ทานกับผักสลัดเข้ากันเป็นอย่างดี"</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- Project Two Row--> */}
                <div class="row gx-0 justify-content-center">
                    <div class="col-lg-6"><img class="img-fluid" src="assets/img/recom/r4.jpg" alt="..." /></div>
                    <div class="col-lg-6 order-lg-first">
                        <div class="bg-black text-center h-100 project">
                            <div class="d-flex h-100">
                                <div class="project-text w-100 my-auto text-center text-lg-right">
                                    <h4 class="text-white">สปาเก็ตตี้ขี้เมาทะเล  / -109 ฿</h4>
                                    <p class="mb-0 text-white-50">"รสชาติจัดจ้านแบบไทยสไตล์ เส้นสปาเก็ตตี้เหนียวนุ่มกำลังดี ผัดคลุกเคล้ากับเครื่องขี้เมาทะเลสูตรพิเศษ เข้มข้น เผ็ดกำลังดี อร่อยจนต้องยกนิ้วให้"</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row gx-0 mb-5 mb-lg-0 justify-content-center">
                    <div class="col-lg-6"><img class="img-fluid" src="assets/img/recom/r5.jpg" alt="..." /></div>
                    <div class="col-lg-6">
                        <div class="bg-black text-center h-100 project">
                            <div class="d-flex h-100">
                                <div class="project-text w-100 my-auto text-center text-lg-left">
                                    <h4 class="text-white">พิซซ่าโฮมเมด / -129 ฿</h4>
                                    <p class="mb-0 text-white-50">"พิซซ่าที่ทุกคนหลงรัก ที่ร้านทำแป้งเอง มีความนุ่ม ฟู กลิ่นหอม พร้อมซอสพิซซ่าสูตรเฉพาะของทางร้าน เครื่องแน่นๆ จัดเต็ม ชีสเยิ้มฉ่ำๆ ละมุน นัวมาก แนะนำต้องมาลอง"</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                {/* <!-- Project Two Row--> */}
                <div class="row gx-0 justify-content-center">
                    <div class="col-lg-6"><img class="img-fluid" src="assets/img/recom/r7.jpg" alt="..." /></div>
                    <div class="col-lg-6 order-lg-first">
                        <div class="bg-black text-center h-100 project">
                            <div class="d-flex h-100">
                                <div class="project-text w-100 my-auto text-center text-lg-right">
                                    <h4 class="text-white">ข้าวผัดกุ้ง / -89 ฿ </h4>
                                    <p class="mb-0 text-white-50">"เมนูคลาสสิคที่ขาดไม่ได้ อิ่ม อร่อย กุ้งสดๆ หอมกลิ่นคั่วกระทะ"</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row gx-0 mb-5 mb-lg-0 justify-content-center">
                    <div class="col-lg-6"><img class="img-fluid" src="assets/img/recom/r8.jpg" alt="..." /></div>
                    <div class="col-lg-6">
                        <div class="bg-black text-center h-100 project">
                            <div class="d-flex h-100">
                                <div class="project-text w-100 my-auto text-center text-lg-left">
                                    <h4 class="text-white">สปาเก็ตตี้หมูสับซอสมะเขือเทศ / -89 ฿</h4>
                                    <p class="mb-0 text-white-50">"เมนูอร่อย เด็กๆ ชอบมาก เส้นสปาเก็ตตี้เหนียวนุ่ม ซอสเข้มข้น ผัดกับหมูสับและไส้กรอกเกรดดี อร่อยเข้ากันมาก"</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- Project Two Row--> */}
                <div class="row gx-0 justify-content-center">
                    <div class="col-lg-6"><img class="img-fluid" src="assets/img/recom/r9.jpg" alt="..." /></div>
                    <div class="col-lg-6 order-lg-first">
                        <div class="bg-black text-center h-100 project">
                            <div class="d-flex h-100">
                                <div class="project-text w-100 my-auto text-center text-lg-right">
                                    <h4 class="text-white">ปีกไก่ทอด  / -79 ฿</h4>
                                    <p class="mb-0 text-white-50">"เมนูทานเล่นง่ายๆ ที่ทานได้ทุกเพศ ทุกวัย ปีกกลางไก่คัดพิเศษ ทอดจนกรอบนอกนุ่มใน"</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row gx-0 mb-5 mb-lg-0 justify-content-center">
                    <div class="col-lg-6"><img class="img-fluid" src="assets/img/recom/r10.jpg" alt="..." /></div>
                    <div class="col-lg-6">
                        <div class="bg-black text-center h-100 project">
                            <div class="d-flex h-100">
                                <div class="project-text w-100 my-auto text-center text-lg-left">
                                    <h4 class="text-white">มาม่าขี้เมาทะเล / -89฿</h4>
                                    <p class="mb-0 text-white-50">"ถึงเครื่องเรื่องขี้เมา อาหารจานด่วนรสแซ่บ เส้นมาม่าเหนียวนุ่ม รสชาติจัดจ้าน เผ็ดกลมกล่อม กุ้ง ปลาหมึกจัดเต็ม"</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row gx-0 justify-content-center">
                    <div class="col-lg-6"><img class="img-fluid" src="assets/img/recom/r6.jpg" alt="..." /></div>
                    <div class="col-lg-6 order-lg-first">
                        <div class="bg-black text-center h-100 project">
                            <div class="d-flex h-100">
                                <div class="project-text w-100 my-auto text-center text-lg-right">
                                    <h4 class="text-white">ยำวุ้นเส้นทะเล / -120 ฿ </h4>
                                    <p class="mb-0 text-white-50">"วุ้นเส้นนุ่มหนึบ ถึงเครื่องทะเล กุ้ง ปลาหมึก ไส้กรอก รสชาติเปรี้ยว เผ็ดพอดี อร่อยแซ่บ โดนใจ"</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default Project